import { forwardRef } from "react";

import type { ReactNode, SyntheticEvent } from "react";

export interface VideoElementProps {
  children?: ReactNode;
  poster?: string;
  title: string;
  onCanPlay: () => void;
  onCanPlayThrough: () => void;
  onEnded: () => void;
  onError: (event: SyntheticEvent) => void;
  onLoadedData: () => void;
  onLoadedMetaData: () => void;
  onLoadStart: () => void;
  onDurationChange: () => void;
  onPause: () => void;
  onPlaying: () => void;
  onProgress: () => void;
  onTimeUpdate: () => void;
  onVolumeChange: () => void;
  onWaiting: () => void;
}

export const VideoElement = forwardRef<HTMLVideoElement, VideoElementProps>(
  function VideoElementImpl(
    {
      children,
      poster,
      title,
      onCanPlay,
      onCanPlayThrough,
      onEnded,
      onError,
      onLoadedData,
      onLoadedMetaData,
      onLoadStart,
      onDurationChange,
      onPause,
      onPlaying,
      onProgress,
      onTimeUpdate,
      onVolumeChange,
      onWaiting,
    },
    ref,
  ) {
    return (
      <video
        aria-hidden={false}
        className="VideoElement"
        controlsList="nodownload nofullscreen"
        crossOrigin="anonymous"
        muted={false}
        playsInline
        poster={poster}
        ref={ref}
        tabIndex={-1}
        title={title}
        x-webkit-airplay="allow"
        onCanPlay={onCanPlay}
        onCanPlayThrough={onCanPlayThrough}
        onEnded={onEnded}
        onError={onError}
        onLoadedData={onLoadedData}
        onLoadedMetadata={onLoadedMetaData}
        onLoadStart={onLoadStart}
        onDurationChange={onDurationChange}
        onPause={onPause}
        onPlaying={onPlaying}
        onProgress={onProgress}
        onTimeUpdate={onTimeUpdate}
        onVolumeChange={onVolumeChange}
        onWaiting={onWaiting}
      >
        {children}
      </video>
    );
  },
);
